const rules = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
};


export default rules;
